import { Flex } from "@mantine/core";
import { Checkbox, Text } from "components";
import { IRootState } from "config/redux";
import { AuthorityConstants, ServiceConstants } from "constant";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { CreditService } from "services";
import { CreditRequestAttachmentTypeResponse } from "types";
import { AppUtils, UserUtils } from "utils";

const { ROLE_CC_C, ROLE_CC_U } = AuthorityConstants;
const { REQUEST_CREDIT_ATTACHMENT_TYPE_DELIVERED_ID, REQUEST_PENDING } = ServiceConstants;

interface CreditRequiredDocumentationItemProps {
  item: CreditRequestAttachmentTypeResponse;
  language: string;
  getName: (item: CreditRequestAttachmentTypeResponse) => string | undefined;
  isEditAllowed: boolean;
}
const CreditRequiredDocumentationItem = ({ item, getName, isEditAllowed }: CreditRequiredDocumentationItemProps) => {

  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CREDIT_ATTACHMENT_TYPE_DELIVERED_ID + item.id]);
  const [delivered, setDelivered] = useState<boolean>(item.delivered);

  useEffect(() => {
      AppUtils.resolveServiceObject(serviceObject, REQUEST_CREDIT_ATTACHMENT_TYPE_DELIVERED_ID + item.id, (val: CreditRequestAttachmentTypeResponse) => setDelivered(val.delivered));
    }, [serviceObject]);

  const changeDelivered = useCallback(() => CreditService.creditAttachmentTypeDelivered(item.id), []);
  const isLoading = useMemo(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);

  return (
    <Flex mb={'md'} key={`credit-attachment-type-${item.id}`} id={`credit-attachment-type-${item.id}`}>
      <Checkbox
        checked={delivered}
        onChange={changeDelivered}
        loading={isLoading}
        readOnly={!isEditAllowed || !UserUtils.hasAnyAuthority([ROLE_CC_C, ROLE_CC_U])}
      />
      <Text ml={'sm'}>{getName(item)}</Text>
    </Flex>
  )
}

export default CreditRequiredDocumentationItem;